
import { MAX_WISHLIST_ITEMS } from "@components/Wishlist/wishlist.config";
import { WishlistModel } from "@redux/modules/api/data/wishlist/@types/wishlist.model";
import { broadcastMessage } from "@redux/modules/value/messages/messages.utils";

export const WISHLIST_MESSAGE_ID = "wishlist-header-alert";

const broadcastWishlistError = (text: string) =>
    broadcastMessage({
        text: text,
        dismissible: true,
        id: WISHLIST_MESSAGE_ID,
        status: "danger",
        activeScroll: false,
    });

const isFull = (wishlist: WishlistModel) =>
    wishlist.products.length >= MAX_WISHLIST_ITEMS;

export { broadcastWishlistError, isFull };
